import React from 'react';
import type { StandupControls } from '../../common/types.tsx';
import { EndStandupButton } from './end-standup-button/index.tsx';
import { StartStandupButton } from './start-standup-button/index.tsx';

export const StandupControlButtons = ({
	isActiveStandup,
	setIsActiveStandup,
	isStandupDisabled,
	boardId,
	render,
}: StandupControls) => {
	return isActiveStandup ? (
		<EndStandupButton render={render} setIsActiveStandup={setIsActiveStandup} boardId={boardId} />
	) : (
		<StartStandupButton
			render={render}
			isStandupDisabled={isStandupDisabled}
			setIsActiveStandup={setIsActiveStandup}
			boardId={boardId}
		/>
	);
};
